export const INSURER_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  address: {
    isRequiredTrim: {
      value: true,
    },
  },
  city: {
    isRequiredTrim: {
      value: true,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  postalCode: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i,
        customMessageKey: "validation.customMessages.postalCodeRegex",
      },
    },
  },

  adminContactEmailAddress: {
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.customMessages.emailAddressRegex",
      },
    },
  },
  salesContactEmailAddress: {
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.customMessages.emailAddressRegex",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/insurerValidationRules.js